import React from 'react';
import { Dialog, DialogContent, Button, Grid, Typography } from '@mui/material';
import { useTheme, useMediaQuery } from '@mui/material';
import { Close } from '@mui/icons-material';
import GuardianImageSuccess from '../../../../assets/icon/Add_guardian_success.svg';
import './MinPromise.css';

const MinPromisePopup3 = ({ handleClose }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <DialogContent>
      <Grid container direction="column" alignItems="center">
        {/* Image */}
        <Grid item>
          <img
            src={GuardianImageSuccess}
            alt="Add Guardian"
            style={{
              width: isMobile ? '120px' : '200px',
              height: 'auto',
              marginBottom: '10px',
            }}
          />
        </Grid>

        {/* Title */}
        <Grid item style={{ marginTop: '20px', width: '100%' }}>
          <Typography
            variant="h3"
            align="left" // Align text to the left
            fontSize={isMobile ? '24px' : '30px'}
            fontWeight="800"
            color="#321b6d"
            style={{ padding: isMobile ? '0 8px' : '0 16px' }}
          >
            Congratulations!
          </Typography>
        </Grid>

        {/* Description */}
        <Grid item style={{ marginTop: '20px' }}>
          <Typography
            variant="body2"
            align="left" // Align text to the left
            fontSize={isMobile ? '12px' : '16px'}
            fontWeight="600"
            color="#321b6d"
            style={{ padding: isMobile ? '0 8px' : '0 16px' }}
          >
            Next Steps: Securing Your Child's Room Your child’s creative space,
            where they will store and grow their digital identity, is ready to
            be secured.
          </Typography>
        </Grid>

        <Grid item style={{ marginTop: '20px' }}>
          <Typography
            variant="body2"
            align="left" // Align text to the left
            fontSize={isMobile ? '12px' : '16px'}
            fontWeight="600"
            color="#321b6d"
            style={{ padding: isMobile ? '0 8px' : '0 16px' }}
          >
            This is where you’ll access valuable insights that will provide
            conversation starters and imagination triggers for your weekly
            20-minute promise.
          </Typography>
        </Grid>

        <Grid item style={{ marginTop: '20px' }}>
          <Typography
            variant="body2"
            align="left" // Align text to the left
            fontSize={isMobile ? '12px' : '16px'}
            fontWeight="600"
            color="#321b6d"
            style={{ padding: isMobile ? '0 8px' : '0 16px' }}
          >
            If your school is sponsoring the Seedlings Plan, expect a coupon
            that will reduce the price to zero.
          </Typography>
        </Grid>
      </Grid>

      {/* Button */}
      <Grid container direction="column" alignItems="center">
        <Grid item width="100%" sx={{ maxWidth: '392px !important' }}>
          <button
            className="Yes_btn"
            style={{
              marginTop: isMobile ? '16px' : '20px',
              fontSize: isMobile ? '14px' : '16px',
              width: '100%',
            }}
            onClick={handleClose}
          >
            Next
          </button>
        </Grid>
      </Grid>
    </DialogContent>
  );
};

export default MinPromisePopup3;
